<div class="content">
  <div class="group" *ngFor="let group of groups">
    <div class="group-content">
      <div class="group-avatar"[style.background-color]="getColorFromName(group.name)">{{group.name.substring(0,1)}}</div>
      <div class="group-text">
        <div class="group-name">{{group.name}}</div>
        <div class="group-desc">{{group.description}} <span *ngIf="isCommunity()">({{getFamiliesLength(group)}} families)</span></div>
      </div>
    </div>
    <div class="action-buttons">
      <button  (click)="showDocuments(group)" mat-icon-button >
        <mat-icon  svgIcon="lib_books"></mat-icon>
      </button>
      <button  (click)="onEdit(group)" mat-icon-button >
        <mat-icon>edit_outline</mat-icon>
      </button>
      <button *ngIf="getFamiliesLength(group)  === 0" (click)="onDelete(group)" mat-icon-button >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </div>
  <div class="add-new-container">
    <button mat-fab color="primary" (click)="onEdit(null)">
   + Add new
    </button>
  </div>
</div>

